import { useEffect, useState } from "react";
import { Badge, Dropdown, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/DeleteModal";
import AdminService from "../../../../services/AdminService";
import { useSelector } from "react-redux";
import { Rules } from "../../../Enums/Rules";
import { toast } from "react-toastify";
import { Translate } from "../../../Enums/Tranlate";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [status, setStatus] = useState(null);
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const adminService = new AdminService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	useEffect(() => {
		setStatus(!item.isBlocked);
	}, [item]);

	const changeStatusToggle = (e) => {
		let data = {
			isBlocked: status,
		};
		adminService.toggleStatus(item.id, data).then((res) => {
			if (res?.status === 200) {
				toast.success(Translate[lang].updated_status_successfully);
				setStatus(!status);
			}
		});
	};

	return (
		<tr key={index}>
			<td>{`${item?.username}`}</td>
			<td>{item?.email}</td>
			<td style={{ direction: "ltr" }}>{item?.phone}</td>
			<td>
				{!!item?.admin_permissions?.length ? (
					<Badge variant="outline-success">
						{item?.admin_permissions[0]?.admin_role?.name}
					</Badge>
				) : (
					<Badge variant="outline-danger">
						{Translate[lang].no_permissions}
					</Badge>
				)}
			</td>
			<td>
				<Form.Check
					type="switch"
					id={`custom-switch${index}`}
					checked={status}
					style={{
						opacity: Auth?.admin?.id === item?.id ? ".7" : "1",
					}}
					disabled={!isExist("update_admin") || Auth?.admin?.id === item?.id}
					onChange={(e) => changeStatusToggle(e)}
				/>
			</td>
			<td>
				{/* {isExist("admin") && ( */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							onClick={() =>
								navigate(`/admins/edit-admin/${item.id}/${item?.username}`, {
									state: { edit: true, id: item.id, item: item },
								})
							}>
							{Translate[lang]?.edit}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							{Translate[lang]?.delete}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.f_name}
					deletedItem={item}
					modelService={adminService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
